import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import logger from '../../utils/logger-rum';

interface Props {
	value: string;
	mono?: boolean;
}

/**
 * Identifiers on this dashboard exist to be pasted into Vonage/LiveKit consoles
 * and support tickets, so every one of them is click to copy. Feedback is local
 * rather than going through the alert service, because this route renders
 * outside the meeting app and has no <Alert /> mounted.
 */
export default function CopyValue({ value, mono = false }: Props) {
	const [copied, setCopied] = useState(false);
	const resetTimer = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => () => clearTimeout(resetTimer.current), []);

	if (!value) return <span className='health-empty'>—</span>;

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(value);
			setCopied(true);
			clearTimeout(resetTimer.current);
			resetTimer.current = setTimeout(() => setCopied(false), 1500);
		} catch (error) {
			logger.error('health dashboard: clipboard write failed', error);
		}
	};

	return (
		<button
			type='button'
			className={classNames('health-copy', { 'health-mono': mono, 'health-copy--copied': copied })}
			onClick={copy}
			title='Click to copy'
		>
			{copied ? 'copied' : value}
		</button>
	);
}
